import { EmptyValue } from '@/components/common/EmptyValue';

const LIST_SEPARATOR = ',';

interface StackedListCellProps {
  listText: string | null | undefined;
}

function splitListText(listText: string | null | undefined): string[] {
  if (!listText) return [];
  const items = listText
    .split(LIST_SEPARATOR)
    .map((item) => item.trim())
    .filter((item) => item !== '');
  return [...new Set(items)];
}

export function StackedListCell({ listText }: StackedListCellProps) {
  const items = splitListText(listText);
  if (items.length === 0) return <EmptyValue />;

  return (
    <span className="flex flex-col gap-0.5 text-xs tabular-nums">
      {items.map((item) => (
        <span key={item} className="whitespace-nowrap">
          {item}
        </span>
      ))}
    </span>
  );
}
